var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81818 16.0612L1 22.3061L13.7273 37L41 7.97959L35.1818 1L13.7273 24.5102L6.81818 16.0612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81818 18.0612L1 24.3061L13.7273 39L41 9.97959L35.1818 3L13.7273 26.5102L6.81818 18.0612Z",
    fill: "#F7D95C",
    stroke: "#263238",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoadd);
export default __webpack_public_path__ + "static/media/promoadd.27f31cb1da168bab313cfdbdc986ec43.svg";
export { ForwardRef as ReactComponent };